import React, { useState, useEffect } from 'react';
import ReactInputMask from 'react-input-mask';
import { Form } from 'semantic-ui-react';
import { DateTime } from 'luxon';
import './FormPeriodo.scss';

function ptDateToJSDate(dateStr) {
    dateStr = dateStr ? dateStr : '';
    if (!DateTime.fromFormat(dateStr, 'dd/MM/yyyy').isValid) {
        return null;
    }
    return DateTime.fromFormat(dateStr, 'dd/MM/yyyy').toJSDate();
}

function FormPeriodo({ label, name, onChange, value }) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        if (onChange) onChange(undefined, { value: [ptDateToJSDate(startDate), ptDateToJSDate(endDate)], name });
        // eslint-disable-next-line
    }, [startDate, endDate]);

    useEffect(() => {
        // pig
        if (value && value.length === 0) {
            setStartDate('');
            setEndDate('');
        }
        else if (value) {
            if (value[0]) {
                setStartDate(DateTime.fromJSDate(value[0]).toFormat('dd/MM/yyyy'));
            }
            if (value[1]) {
                setEndDate(DateTime.fromJSDate(value[1]).toFormat('dd/MM/yyyy'));
            }
        }
    }, [value]);

    function onChangeInput(ev) {
        const target = ev.target;
        if (target.name === 'startDate') {
            setStartDate(target.value);
        } else if (target.name === 'endDate') {
            setEndDate(target.value);
        }
        return undefined;
    }

    return (
        <Form.Field className="form-periodo">
            <label>{label || ''}</label>
            <div className="input-wrapper">
                <ReactInputMask mask="99/99/9999" name="startDate" onChange={onChangeInput} value={startDate || ''} />
                <ReactInputMask mask="99/99/9999" name="endDate" onChange={onChangeInput} value={endDate || ''} />
            </div>
        </Form.Field>
    );
}
export default React.memo(FormPeriodo);
